import { render, staticRenderFns } from "./globalLimitTimeg.vue?vue&type=template&id=1d8cbce2&scoped=true&"
import script from "./globalLimitTimeg.vue?vue&type=script&lang=js&"
export * from "./globalLimitTimeg.vue?vue&type=script&lang=js&"
import style0 from "./globalLimitTimeg.vue?vue&type=style&index=0&id=1d8cbce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8cbce2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/globalLimitTimeg.vue
// module id = null
// module chunks = 